import { render, staticRenderFns } from "./TakipEkleView.vue?vue&type=template&id=8a10eb9a&scoped=true"
import script from "./TakipEkleView.vue?vue&type=script&lang=ts"
export * from "./TakipEkleView.vue?vue&type=script&lang=ts"
import style0 from "./TakipEkleView.vue?vue&type=style&index=0&id=8a10eb9a&prod&scoped=true&lang=css"
import style1 from "./TakipEkleView.vue?vue&type=style&index=1&id=8a10eb9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a10eb9a",
  null
  
)

export default component.exports